import React from 'react';
import { OfferConfiguration } from '../../../configurations/config-data-sections/link-to-offer.configuration';
import { OfferBase } from "./offer-base";

export class WelcomeOffer extends OfferBase {
    id = "welcomeBonus";
    analyticsCategory = "Conversion";

    updateConfig(offerConfig: OfferConfiguration) {
        this.offerConfig = offerConfig;
    }

    async shouldBeVisible(): Promise<boolean> {
        const cStatus = (await this.services.cmsSegmentation).isCstatus;    // can be null
        return !this.services.user.isAuthorized && (cStatus === false) && !this.services.miniOrbit.isEnabled && await super.shouldBeVisible();
    }
    
    shouldUseLinkToOfferAnimation(): boolean {
        return true;
    }

    render(): React.ReactNode {
        let IconComponent = this.services.theme.currentTheme.icons.linkToOfferIcon;
        return (
            <IconComponent size={4} sizeIsHeight />
        );
    }
}
